import React from 'react';
import PropTypes from 'prop-types';

const LeadNote = props => {
  const { color: _color, width: _width, height: _height, ...other } = props;

  return (
    <svg id="グループ_4218" data-name="グループ 4218" xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" {...other}>
      <circle id="楕円形_28" data-name="楕円形 28" cx="15.5" cy="15.5" r="15.5" fill="#f2f6ff" />
      <g id="グループ_4125" data-name="グループ 4125" transform="translate(-1144.259 -742.877)">
        <rect id="長方形_667" data-name="長方形 667" width="13.518" height="9.802" rx="2" transform="translate(1153 753)" fill="#a4c3ff" />
        <path id="多角形_6" data-name="多角形 6" d="M2.57.76a.5.5,0,0,1,.868,0L5.58,4.509a.5.5,0,0,1-.434.748H.862a.5.5,0,0,1-.434-.748Z" transform="translate(1163.104 765.806) rotate(180)" fill="#a4c3ff" />
        <path id="パス_3694" data-name="パス 3694" d="M.87-8.224h.883V-9.36H.87ZM2.588-4.558H1.83V-7.516H.2v.659H.968v2.3H.2v.666H2.588Z" transform="translate(1158.733 764.642)" fill="#fff" />
      </g>
    </svg>
  );
}

LeadNote.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

LeadNote.defaultProps = {
  color: '#a4c3ff',
  width: 31,
  height: 31,
};

export default LeadNote;



// WEBPACK FOOTER //
// ./src/components/Icons/LeadNote.jsx